import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalLoadingState {
  isLoading: boolean;
  loadingCount: number;
  message: string | null;
}

const initialState: GlobalLoadingState = {
  isLoading: false,
  loadingCount: 0,
  message: null,
};

const globalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState,
  reducers: {
    showGlobalLoading: (state, action: PayloadAction<string | undefined>) => {
      state.loadingCount += 1;
      state.isLoading = true;
      if (action.payload) {
        state.message = action.payload;
      }
    },
    hideGlobalLoading: (state) => {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
      if (state.loadingCount === 0) {
        state.isLoading = false;
        state.message = null;
      }
    },
    setGlobalLoadingMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
    resetGlobalLoading: (state) => {
      state.isLoading = false;
      state.loadingCount = 0;
      state.message = null;
    },
  },
});

export const {
  showGlobalLoading,
  hideGlobalLoading,
  setGlobalLoadingMessage,
  resetGlobalLoading,
} = globalLoadingSlice.actions;

export const globalLoadingReducer = globalLoadingSlice.reducer;

export type GlobalLoadingStateType = typeof initialState;
